module.exports = __webpack_public_path__ + "files/4482d4c7e0af40827b5bcbbe91479145.svg";